/**
 * @file Terminus Constants
 * @license Apache Version 2
 * Constants representing API actions
 */

module.exports = Object.freeze({
  POST: 'POST',
  GET: 'GET',
  DELETE: 'DELETE',
  PUT: 'PUT',
  HEAD: 'HEAD',
  QUERY_DOCUMENT: 'QUERY_DOCUMENT',
  SQUASH_BRANCH: 'SQUASH_BRANCH',
  UPDATE_SCHEMA: 'UPDATE_SCHEMA',
  CONNECT: 'connect',
  CREATE_DATABASE: 'create_database',
  READ_DATABASE: 'read_database',
  UPDATE_DATABASE: 'update_database',
  CREATE_USER: 'create_user',
  READ_USER: 'read_user',
  UPDATE_USER: 'update_user',
  CREATE_ORGANIZATION: 'create_organization',
  READ_ORGANIZATION: 'read_organization',
  UPDATE_ORGANIZATION: 'update_organization',
  GET_ROLES: 'get_roles',
  UPDATE_ROLES: 'update_roles',
  CREATE_GRAPH: 'create_graph',
  GET_TRIPLES: 'get_triples',
  INSERT_TRIPLES: 'insert_triples',
  UPDATE_TRIPLES: 'update_triples',
  CLASS_FRAME: 'class_frame',
  WOQL_QUERY: 'woql_query',
  CLONE: 'clone',
  CSV: 'csv',
  WOQL: 'woql',
  FRAME: 'frame',
  PUSH: 'push',
  PULL: 'pull',
  FETCH: 'fetch',
  REBASE: 'rebase',
  RESET: 'reset',
  BRANCH: 'branch',
  REMOTE: 'remote',
  CREATE_REMOTE: 'create_remote',
  GET_REMOTE: 'get_remote',
  UPDATE_REMOTE: 'update_remote',
  DELETE_REMOTE: 'delete_remote',
  RESET_BRANCH: 'reset_branch',
  ADD_CSV: 'add_csv',
  GET_CSV: 'get_csv',
  UPDATE_CSV: 'update_csv',
  MESSAGE: 'message',
  ACTION: 'action',
  INFO: 'info',
  OPTIMIZE_SYSTEM: 'optimize_system',
  GET_DIFF: 'getDiff',
  PATCH: 'patch',
});
